import { useEffect, useState } from 'react';

const useActiveElement = () => {
    const [active, setActive] = useState(document.activeElement);

    const handleFocusChange = () => {
        setActive(document.activeElement);
    };

    useEffect(() => {
        document.addEventListener('focusin', handleFocusChange);
        document.addEventListener('focusout', handleFocusChange);
        return () => {
            document.removeEventListener('focusin', handleFocusChange);
            document.removeEventListener('focusout', handleFocusChange);
        };
    }, []);

    return active;
};

export default useActiveElement;